import { z } from 'zod/v4';

export const assetInvitationTypeOptions = [
  'Sms',
  'Email',
  'Email and Sms',
] as const;

export const assetInvitationTypeSchema = z.enum(assetInvitationTypeOptions);

export type AssetInvitationType = z.infer<typeof assetInvitationTypeSchema>;
